import { type FC, memo } from 'react';

import { type Advantage, Advantages } from '@/components/Advantages';
import { ImageComponent } from '@/components/Image';
import useEstonia from '@/hooks/estonia';
import { useGetCommonStore } from '@/store';
import { ScContainer } from '@/styles/common';
import {
  ScBannerTitle,
  ScContent,
  ScRegBanner,
  ScRegBannerContainer,
  ScRegFormPlug,
  type ScRegistrationBannerProps,
} from './styled';

export interface RegSlideProps extends ScRegistrationBannerProps {
  characterImage?: string;
  advantages: Advantage[];
  title?: string;
  titleColor?: string;
  backgroundDesktop?: string;
  backgroundMobile?: string;
  loading: 'eager' | 'lazy';
}

export const RegBanner: FC<RegSlideProps> = memo(
  ({
    characterImage,
    title,
    titleColor,
    advantages,
    backgroundDesktop,
    backgroundMobile,
    loading,
    ...props
  }) => {
    const { isEstonia } = useEstonia();
    const useCommonStore = useGetCommonStore();

    const isMobileDevice = useCommonStore.use.isMobileDevice();

    return (
      <ScRegBanner height={props.height}>
        <ImageComponent
          alt="slider bg"
          className="slider-bg"
          fill
          loading={loading}
          src={(isMobileDevice ? backgroundMobile : backgroundDesktop) || ''}
        />
        <ScContainer relative>
          <ScRegBannerContainer isEstonia={isEstonia}>
            <ScRegFormPlug />
            <ScContent>
              <ScBannerTitle titleColor={titleColor}>{title}</ScBannerTitle>
              <Advantages advantages={advantages} />
              <div className="character-image">
                <ImageComponent
                  alt="characters"
                  className="characters"
                  fill
                  loading="eager"
                  priority
                  src={characterImage || ''}
                />
              </div>
            </ScContent>
          </ScRegBannerContainer>
        </ScContainer>
      </ScRegBanner>
    );
  }
);
